export const sampleWorkspaceEn = {
  required: "Required",
  editTitle: "Edit sample order",
  groups: {
    partner: "Partner", partnerHint: "Supplier or customer (by order type) and the contact fixed on the order.",
    schedule: "Schedule", scheduleHint: "Order date, delivery date, team and status.", scheduleHintNew: "Order date, delivery date and team. A new order always starts as Draft.",
    shipping: "Sample shipment",
    lines: "Sample lines",
  },
  filled: "{{count}} filled",
  "expand": "Expand details",
  "collapse": "Collapse details",
  "quantityHint": "Request qty and retained qty are independent sample counts. Enter the request quantity explicitly; retained may exceed requested. These counts do not change stock.",
  "customerRequired": "Select a customer.",
  "duplicateIdentity": "This Code and Sub Ref are already on the order.",
  "saveHint": "Save applies order details, status, sample lines and attachments together.",
  "saveBeforeActions": "Save your changes before printing or adding samples to product data.",
  "printPreview": "Print preview",
  "catalogPreview": "Review products to add",
  "catalogHint": "Match Code and Sub Ref together. New products keep sample specifications, image and supplier, start with zero stock and Pending approval. Existing products are linked without overwriting their data.",
  "catalogDone": "Product data updated and sample lines linked.",
  "confirmCatalog": "Confirm product updates",
  "nothingToAdd": "All eligible sample lines are already linked.",
  "create": "Create product",
  "link": "Link existing product",
  "alreadyLinked": "Already linked",
  "incomplete": "Complete code, description and type first.",
  "ambiguous": "Multiple matches: choose the exact product in the editor.",
  "deliveryFrom": "Delivery from",
  "deliveryTo": "Delivery to",
  "clearFilters": "Clear filters",
  "sample_ambiguous_product": "More than one product matches this Code and Sub Ref. Choose the exact product from the catalog.",
  "sample_party_unavailable": "The selected party is unavailable. Choose an active supplier or customer.",
  "sample_catalog_changed": "The order or catalog changed. Refresh this preview before confirming."
};

export const sampleWorkspaceVi = {
  required: "Bắt buộc",
  editTitle: "Sửa đơn hàng mẫu",
  groups: {
    partner: "Đối tác", partnerHint: "Nhà cung cấp hoặc khách hàng (theo loại đơn) và người liên hệ chốt trên đơn.",
    schedule: "Tiến độ", scheduleHint: "Ngày đặt, ngày giao, bộ phận và trạng thái.", scheduleHintNew: "Ngày đặt, ngày giao và bộ phận. Đơn mới luôn bắt đầu ở trạng thái Nháp.",
    shipping: "Gửi hàng mẫu",
    lines: "Dòng mẫu",
  },
  filled: "{{count}} ô có dữ liệu",
  "expand": "Mở chi tiết",
  "collapse": "Thu gọn",
  "quantityHint": "Số lượng yêu cầu và số mẫu giữ lại là hai số độc lập. Nhập rõ số lượng yêu cầu; số giữ lại có thể lớn hơn. Các số này không thay đổi tồn kho.",
  "customerRequired": "Chọn khách hàng.",
  "duplicateIdentity": "Code và Sub Ref này đã có trên đơn.",
  "saveHint": "Lưu đồng thời thông tin đơn, trạng thái, dòng mẫu và tài liệu đính kèm.",
  "saveBeforeActions": "Lưu thay đổi trước khi in hoặc chuyển mẫu vào danh mục sản phẩm.",
  "printPreview": "Xem trước bản in",
  "catalogPreview": "Xem trước sản phẩm sẽ thêm",
  "catalogHint": "Đối chiếu cả Code và Sub Ref. Sản phẩm mới giữ quy cách, ảnh và nhà cung cấp của mẫu; tồn kho bắt đầu bằng 0, trạng thái chờ duyệt. Sản phẩm đã có chỉ được liên kết, không ghi đè dữ liệu.",
  "catalogDone": "Đã cập nhật danh mục và liên kết các dòng mẫu.",
  "confirmCatalog": "Xác nhận cập nhật sản phẩm",
  "nothingToAdd": "Các dòng mẫu phù hợp đã được liên kết.",
  "create": "Tạo sản phẩm",
  "link": "Liên kết sản phẩm đã có",
  "alreadyLinked": "Đã liên kết",
  "incomplete": "Bổ sung mã, mô tả và loại sản phẩm.",
  "ambiguous": "Có nhiều kết quả: chọn đúng sản phẩm trong biểu mẫu.",
  "deliveryFrom": "Ngày giao từ",
  "deliveryTo": "Ngày giao đến",
  "clearFilters": "Xóa bộ lọc",
  "sample_ambiguous_product": "Có nhiều sản phẩm trùng Code và Sub Ref. Hãy chọn đúng sản phẩm từ danh mục.",
  "sample_party_unavailable": "Đối tác đã chọn không khả dụng. Chọn nhà cung cấp hoặc khách hàng đang hoạt động.",
  "sample_catalog_changed": "Đơn hoặc danh mục đã thay đổi. Tải lại bản xem trước rồi xác nhận."
};

export const sampleWorkspaceZh = {
  required: "必填",
  editTitle: "编辑样品单",
  groups: {
    partner: "往来对象", partnerHint: "供应商或客户（依订单类型），以及固定在订单上的联系人。",
    schedule: "进度", scheduleHint: "下单日期、交货日期、部门与状态。", scheduleHintNew: "下单日期、交货日期与部门。新样品单一律从草稿开始。",
    shipping: "样品寄送",
    lines: "样品明细",
  },
  filled: "已填 {{count}} 项",
  "expand": "展开明细",
  "collapse": "收起明细",
  "quantityHint": "要求数量与保留样品数量各自独立。请明确填写要求数量；保留量可较大。这些数量不会变更库存。",
  "customerRequired": "请选择客户。",
  "duplicateIdentity": "此代码及子参考已在订单中。",
  "saveHint": "保存将一并应用订单信息、状态、样品明细及附件。",
  "saveBeforeActions": "请先保存变更，再打印或将样品加入产品资料。",
  "printPreview": "打印预览",
  "catalogPreview": "预览将新增的产品",
  "catalogHint": "依代码及子参考比对。新产品保留样品规格、图片及供应商，库存为零、待审核。现有产品仅关联，不覆盖数据。",
  "catalogDone": "产品资料已更新，样品明细已关联。",
  "confirmCatalog": "确认更新产品",
  "nothingToAdd": "所有符合条件的样品明细均已关联。",
  "create": "创建产品",
  "link": "关联现有产品",
  "alreadyLinked": "已关联",
  "incomplete": "请先补齐代码、描述及类型。",
  "ambiguous": "有多个匹配项，请在编辑器选择正确产品。",
  "deliveryFrom": "交货起始日",
  "deliveryTo": "交货截止日",
  "clearFilters": "清除筛选",
  "sample_ambiguous_product": "多项产品符合此代码及子参考，请从目录选择正确产品。",
  "sample_party_unavailable": "所选对象无法使用，请选择有效供应商或客户。",
  "sample_catalog_changed": "订单或目录已变更，请重新预览后确认。"
};
